
import { computed, defineComponent, PropType } from 'vue'
import { RouteLocation } from 'vue-router'

const colors = ['primary', 'secondary', 'danger', 'success', 'warning', 'info', 'light', 'dark']

export default defineComponent({
  name: 'Btn',
  props: {
    block: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      validate: (value: string) => colors.includes(value),
    },
    to: {
      type: Object as PropType<RouteLocation>,
    },
    href: {
      type: String,
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup(props) {
    const classes = computed(() => {
      const c = ['ui-btn']
      if (props.block) {
        c.push('ui-btn--block')
      }
      if (props.color && colors.includes(props.color)) {
        c.push(`ui-btn--${props.color}`)
      }
      if (props.disabled) {
        c.push('ui-btn--disabled')
      }
      return c
    })
    const is = computed(() => {
      if (props.to) {
        return 'router-link'
      }
      if (props.href) {
        return 'a'
      }
      return 'button'
    })
    return {
      classes,
      is,
    }
  },
})
